<template>
  <div class="product-card-grid-description" :class="cssClass">
    <span v-if="title !== undefined && title.length > 0" class="product-card-grid-description-title">{{title}}</span>
    {{description}}
  </div>
</template>

<script>
export default {
  name: "DescriptionTemplate",
  props: ["title", "description", "cssClass"],
}
</script>

<style lang="scss" scoped>
  .product-card-grid-description {
    font-size: .875rem;
    line-height: .875rem;
    margin-top:0.25rem;

    &-title {
      font-family: 'Panton Bold';
      margin: 0 .25rem 0 0
    }
  }
</style>